import { store } from '@/store';

const state = () => ({
    notes: [
        {
            id: null,
            active: false,
            loaded: false,
            title: '會員服務條款',
            insCategory: 'Common',
            noteType: 1,
            content: null,
            date: null,
            pdfUrl: null,
            confirmed: false,
            read: false,
            estimateDate: null,
            order: null,
            scrollEnd: 0,
        },
        {
            id: null,
            active: false,
            loaded: false,
            title: '個人資料告知事項',
            insCategory: 'Common',
            noteType: 2,
            content: null,
            date: null,
            pdfUrl: null,
            confirmed: false,
            read: false,
            estimateDate: 'PersonalNoteDate',
            order: null,
            scrollEnd: 0,
        },
        {
            id: null,
            active: false,
            loaded: false,
            title: '網路投保服務定型化契約',
            insCategory: 'Common',
            noteType: 3,
            content: null,
            date: null,
            pdfUrl: null,
            confirmed: false,
            read: false,
            estimateDate: 'ServiceNoteDate',
            order: null,
            scrollEnd: 0,
        },
        {
            id: null,
            active: false,
            loaded: false,
            title: '網路投保注意及聲明事項',
            insCategory: '',
            noteType: 4,
            content: null,
            date: null,
            pdfUrl: null,
            confirmed: false,
            read: false,
            estimateDate: 'InsuranceNoteDate',
            order: null,
            scrollEnd: 0,
        },
        {
            id: null,
            active: false,
            loaded: false,
            title: '投保須知',
            insCategory: '',
            noteType: 5,
            content: null,
            date: null,
            pdfUrl: null,
            confirmed: false,
            read: false,
            estimateDate: 'KYCDate',
            order: null,
            scrollEnd: 0,
        },
        {
            id: null,
            active: false,
            loaded: false,
            title: '商品條款',
            insCategory: '',
            noteType: 6,
            content: null,
            date: null,
            pdfUrl: null,
            confirmed: false,
            read: false,
            estimateDate: null,
            order: null,
            scrollEnd: 0,
        },
        {
            id: null,
            active: false,
            loaded: false,
            title: '折舊率條款',
            insCategory: 'Car',
            noteType: 7,
            content: null,
            date: null,
            pdfUrl: null,
            confirmed: false,
            read: false,
            estimateDate: null,
            order: null,
            scrollEnd: 0,
        },
    ],
});

const actions = {};

const getters = {
    /**
     * 該畫面要顯示的聲明內容
     * @param {*} state
     * @returns {Array}
     */
    activeNotes: (state) => {
        return _.filter(state.notes, 'active');
    },
    /**
     * 聲明事項代號用在 components
     * @param {*} state
     * @returns
     */
    getByNoteType: (state) => (value) => {
        return _.find(state.notes, { noteType: value });
    },
    /**
     * 聲明事項代號用在 views
     * @param {*} state
     * @returns
     */
    getByNoteTypes: (state) => (value) => {
        return _.filter(state.notes, (o) => _.includes(value, o.noteType));
    },
};

const mutations = {
    /**
     * 因為每次需要 load 的聲明事項項次不同， active 屬性是告知此次是否包含這個項次，此功能是把所有項次都設為 false，實際作用是要在 load 新的聲明事項前清掉舊項目
     * @param {*} state
     */
    setInactivity(state) {
        for (let i = 0; i < state.notes.length; i++) {
            state.notes[i].active = false;
        }
    },
    /**
     * 將聲明事項設為未讀取
     * @param {*} state
     */
    setAllUnread(state) {
        for (let i = 0; i < state.notes.length; i++) {
            state.notes[i].read = false;
        }
    },
    /**
     * 設定
     * @param {*} state
     */
    setInsCategory(state) {
        for (let i = 0; i < state.notes.length; i++) {
            if (!state.notes[i].insCategory) {
                state.notes[i].insCategory = store.state.insCategory;
            }
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
